import { useState } from 'react';
import {
  Chip,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const issueSecondary = issue => {
  if (!Array.isArray(issue.emailIssues) || issue.emailIssues.length === 0) return null;
  return issue.emailIssues
    .map(entry => (typeof entry === 'string' ? entry : entry?.message))
    .filter(Boolean)
    .join(' · ');
};

// Validation result chip: green "Flow vollständig" or orange "{n} Hinweise";
// clicking opens a popover listing all issues (click = jump to block).
const ValidationStatusChip = ({ validation, onIssueClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  if (!validation) return null;
  const issues = validation.issues || [];
  const isValid = Boolean(validation.valid) && issues.length === 0;

  if (isValid) {
    return (
      <Chip
        size='small'
        color='success'
        variant='outlined'
        icon={<CheckCircleOutlineIcon />}
        label='Flow vollständig'
      />
    );
  }

  return (
    <>
      <Chip
        size='small'
        color='warning'
        variant='outlined'
        icon={<WarningAmberIcon />}
        label={issues.length === 1 ? '1 Hinweis' : `${issues.length} Hinweise`}
        onClick={event => setAnchorEl(event.currentTarget)}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <List dense sx={{ maxWidth: 380 }}>
          {issues.map((issue, index) => (
            <ListItemButton
              key={`${issue.code || 'issue'}-${index}`}
              onClick={() => {
                setAnchorEl(null);
                onIssueClick(issue);
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <ErrorOutlineIcon color='warning' fontSize='small' />
              </ListItemIcon>
              <ListItemText primary={issue.message} secondary={issueSecondary(issue)} />
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default ValidationStatusChip;
